import React, { FC } from "react";

import SecurityTopic from "@/pages/SecurityAwareness/components/SecurityTopic";
import { ITopic, SecurityTopicEnum } from "@/pages/SecurityAwareness/types";
import { password2FaQuiz, password2FaSlides } from "@/constants/passwords_2fa";

const Password2Fa: FC<ITopic> = ({
  handleNextTopic,
  isPassed,
  setTestResults,
}) => {
  return (
    <SecurityTopic
      slides={password2FaSlides}
      quizName={SecurityTopicEnum.Password2Fa}
      quizList={password2FaQuiz}
      handleNextTopic={handleNextTopic}
      isPassed={isPassed}
      setTestResults={setTestResults}
    />
  );
};

export default Password2Fa;
